import {useEffect, useState} from "react";

import LoanFilterModal from "../modals/loan/LoanFilterModal";
import { useTranslation } from "../../hooks/useTranslation";

export function LoanFilter({awailableColumns, selectedColumns, toggleColumn, setFilter, filter, setShowModalNew}) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const isFilterState = (state) => {
        return filter.current_state_id.includes(state);
    }

    const toggleFilterState = (state) => {
        if (isFilterState(state)) {
            filter.current_state_id.splice(filter.current_state_id.indexOf(state), 1);
        } else {
            filter.current_state_id.push(state);
        }
        setFilter({...filter});
        console.log(filter)
    }

    return (
        <div
            className="d-lg-flex justify-content-end text-end text-md-start"
            data-kt-customer-table-toolbar="base"
        >
              <span className="d-none d-md-inline">
                <button
                    type="button"
                    className={
                        "btn me-3 mb-2 " +
                        (isFilterState("1") ? "btn-info" : "btn-secondary")
                    }
                    onClick={() => toggleFilterState("1")}
                >
                  {t("loans.registered")}
                </button>
                <button
                    type="button"
                    className={
                        "btn me-3 mb-2 " +
                        (isFilterState('2') ? "btn-warning" : "btn-secondary")
                    }
                    onClick={() =>
                        toggleFilterState("2")
                    }
                >
                  {t("loans.approved")}
                </button>
                <button
                    type="button"
                    className={
                        "btn me-3 mb-2 " +
                        (isFilterState('-1') ? "btn-danger" : "btn-secondary")
                    }
                    onClick={() =>
                        toggleFilterState("-1")
                    }
                >
                  {t("loans.cancelled")}
                </button>
              </span>


            <button type="button" className="btn btn-primary me-3"
                    onClick={() => setShowModalNew(true)}
            >
                <i className="ki-duotone ki-plus fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>{t("loans.newLoan")}
            </button>

            <button
                type="button"
                className="btn btn-light-primary me-3"
                onClick={() => setShowModal(true)}
            >
                <i className="ki-duotone ki-filter fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
                {t("common.filter")}
            </button>

            <LoanFilterModal
                filter={filter}
                setFilter={setFilter}
                awailableColumns={awailableColumns}
                toggleColumn={toggleColumn}
                selectedColumns={selectedColumns}
                show={showModal}
                handleClose={() => setShowModal(false)}
            />

        </div>
    )
}